module.exports = __webpack_public_path__ + "mariah-3.db4d9253.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cutouts/mariah-3.svg
 ** module id = 388
 ** module chunks = 0
 **/